export default {
  settingOrderMoney: {
    amountType: '金额类型',
    unlimited: '不限',

    table: {
      priority: '优先级',
      amountType: '金额类型',
      amount: '金额',
      logistics: '指定物流',
      business: '指定业务',
      updater: '更新人',
      lastUpdated: '最近更新时间',
    },

    dialog: {
      addTitle: '新建订单金额配置',
      editTitle: '编辑订单金额配置',
      amountRange: '金额区间',
      amountValid: '请输入金额区间',
      logistics: '指定物流',
      business: '指定业务',
      priority: '优先级',
      priorityValid: '请输入优先级',
      selectAmountType: '请选择金额类型',
      selectLogistics: '请选择指定物流',
      selectBusiness: '请选择指定业务',
      selectLogisticsValid: '请先选择所属物流商',
    }

  }
};
